import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionProgressResponse } from './get-collection-progress-response';
import { getCollectionProgressResponseSchema } from './get-collection-progress-response';

export async function getCollectionProgressApi(
  collectionId: number,
): Promise<IValidatedResponse<IGetCollectionProgressResponse>> {
  return getRequest<IGetCollectionProgressResponse>({
    path: `/progress/collections/${collectionId}`,
    schema: getCollectionProgressResponseSchema,
  });
}
